module.exports = __webpack_public_path__ + "static/img/sph.01f9439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/sph.png
// module id = fhXB
// module chunks = 51